import { useState } from "react";
import { supabase } from "../lib/supabase";
import { motion } from "framer-motion";

export default function Feedback() {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!message) {
      alert("Please enter feedback before submitting.");
      return;
    }

    setLoading(true);

    const { error } = await supabase.from("feedback").insert([
      {
        message,
        email
      }
    ]);

    setLoading(false);

    if (error) {
      console.error(error);
      alert("Something went wrong. Try again.");
    } else {
      setSubmitted(true);
      setMessage("");
      setEmail("");
    }
  };

  return (
    <div className="bg-black text-white min-h-screen p-6 max-w-xl mx-auto">

      <h1 className="text-2xl font-bold text-center mb-6">
        💬 Feedback
      </h1>

      {!submitted ? (
        <div className="space-y-4">

          <input
            type="email"
            placeholder="Email (optional)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full p-3 rounded-xl bg-white text-black"
          />

          <textarea
            placeholder="What can we improve? What do you want to see?"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="w-full p-3 rounded-xl bg-white text-black h-32"
          />

          <button
            onClick={handleSubmit}
            className="w-full bg-green-500 p-3 rounded-xl"
          >
            {loading ? "Submitting..." : "Submit Feedback"}
          </button>

        </div>
      ) : (
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4, type: "spring", stiffness: 120 }}
          className="text-center mt-10 space-y-4"
        >
          <div className="text-4xl">✅</div>

          <p className="text-lg font-semibold">
            Feedback Submitted
          </p>

          <p className="text-sm opacity-70">
            Appreciate you helping improve Terpivo 🙏
          </p>

          <button
            onClick={() => setSubmitted(false)}
            className="mt-4 bg-white/10 hover:bg-white/20 px-4 py-2 rounded-xl transition"
          >
            Send More Feedback
          </button>
        </motion.div>
      )}
    </div>
  );
}